import {
  Autocomplete,
  Backdrop,
  CircularProgress,
  MenuItem,
  TextField,
  Toolbar,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { getCorporations, getPCS, getpreference } from "../API/nimble";
import { useLoaderData } from "react-router-dom";
import dayjs from "dayjs";
import { useFormContext } from "./FormContext";
 
const currentYear = dayjs().year();
const yearData = Array.from({ length: 11 }, (_, i) => String(currentYear - i));
const years = yearData.reverse(); 

export const SLOT_PROPS = {
  input: {
    disableUnderline: true,
    style: { borderRadius: "6px", border: "1px solid lightgrey" },
  },
};

export const DEFAULT_TEXTFIELD_STYLES = { minWidth: 200 };

export const months = Array.from({ length: 12 }, (_, i) =>
  dayjs().month(i).format("MMM")
);
const lastMonth = dayjs().subtract(1, "month").format("MMM");

const Header = ({ PCS, setPCS, actions }) => {
  const {  corporationID, PCID = "", month, year,urlInfo } = useLoaderData();
  const [corporations, setCorporations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [preference, SetPreference] = useState();

  const { formValues, setFormValues } = useFormContext();

  useEffect(() => {
    async function getData() {
      setLoading(true);
      let data = await getCorporations(urlInfo);
      const corporationList = data["Corporations"] || [];

      const modifiedList = [
        { ID: "", Name: "--select--", LegalName: "--select--" },
        ...corporationList,
      ];
      setCorporations(modifiedList);

      const selectedCorporation =
        modifiedList.find(
          (corp) => String(corp.ID) === String(corporationID)
        ) || modifiedList[0];

      const monthCheck = month || dayjs().subtract(1, "month").format("MMM");
      let yearCheck =
        !month && monthCheck === "Dec"
          ? dayjs().subtract(1, "year").format("YYYY")
          : year || dayjs().format("YYYY");
      setFormValues((prev) => ({
        ...prev,
        corporation: selectedCorporation,
        year: yearCheck,
        month: monthCheck,
      }));

      setLoading(false);
    }

    getData();
  }, []);

  useEffect(() => {
    const userPreference = async () => {
      const response = await getpreference( urlInfo);
      SetPreference(response);
    };
    userPreference();
  }, []);

  const corporation = formValues.corporation;

  useEffect(() => {
    async function getData() {
      setLoading(true);
      let data = await getPCS (corporation["ID"],urlInfo);
      setPCS(data);
      setFormValues((prev) => ({
        ...prev,
        pc: PCID || "",
        readyToFetch: true,
      }));
      setLoading(false);
    }
    if (corporation !== null && corporation["ID"] !== "") getData();
  }, [corporation]);

  return (
    <>
      {loading ? (
        <Backdrop
          open
          sx={(theme) => ({
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          })}
        >
          <CircularProgress />
        </Backdrop>
      ) : (
        <Toolbar sx={{ gap: 2 }}>
          <Autocomplete
            disableClearable={true}
            sx={{ minWidth: 300 }}
            options={corporations}
            getOptionLabel={(option) =>
              preference ? option.LegalName : option.Name
            }
            value={corporation}
            onChange={(_, corporation) =>
              setFormValues((prev) => ({ ...prev, corporation, pc: "" }))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Corporations"
                slotProps={{
                  input: {
                    ...params.InputProps,
                    ...SLOT_PROPS.input,
                  },
                }}
              />
            )}
          />

          {PCS.length !== 0 && (
            <TextField
              sx={{ ...DEFAULT_TEXTFIELD_STYLES }}
              select
              label="Profit Center"
              value={formValues.pc}
              onChange={(e) =>
                setFormValues((prev) => ({ ...prev, pc: e.target.value }))
              }
              slotProps={SLOT_PROPS}
            >
              {PCS.map((option) => (
                <MenuItem key={option.ID} value={option.ID}>
                  {option.Name}
                </MenuItem>
              ))}
            </TextField>
          )}

          <TextField
            select
            label="Year"
            value={formValues.year}
            onChange={(e) =>
              setFormValues((prev) => ({ ...prev, year: e.target.value }))
            }
            slotProps={SLOT_PROPS}
          >
            {years.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Month"
            value={formValues.month}
            onChange={(e) =>
              setFormValues((prev) => ({ ...prev, month: e.target.value }))
            }
            slotProps={SLOT_PROPS}
          >
            {months.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>

          {actions}
        </Toolbar>
      )}
    </>
  );
};

export default Header;
